import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { availabilityShape, bibShape, branchShape, subscriptionShape } from '@bibliocommons/bc-prop-types';

import useStackMap from 'app/hooks/useStackMap';
import bibItemShape from 'app/shapes/bibItemShape';
import BranchAvailabilityInfo from './BranchAvailabilityInfo';

const BranchAvailabilityInfoContainer = ({
  bib,
  bibItems,
  handleAvailabilityButtonClick,
  preferredBranches,
  realtimeAvailability,
  subscriptions
}) => {
  const { fetchMap: fetchStackMap, state: stackMapState } = useStackMap();

  return (
    <BranchAvailabilityInfo
      bib={bib}
      bibItems={bibItems}
      fetchStackMap={fetchStackMap}
      handleAvailabilityButtonClick={handleAvailabilityButtonClick}
      preferredBranches={preferredBranches}
      realtimeAvailability={realtimeAvailability}
      stackMapState={stackMapState}
      subscriptions={subscriptions}
    />
  );
};

BranchAvailabilityInfoContainer.propTypes = {
  bib: bibShape.isRequired,
  bibItems: ImmutablePropTypes.listOf(bibItemShape).isRequired,
  handleAvailabilityButtonClick: PropTypes.func,
  preferredBranches: ImmutablePropTypes.listOf(branchShape).isRequired,
  realtimeAvailability: availabilityShape.isRequired,
  subscriptions: ImmutablePropTypes.listOf(subscriptionShape).isRequired
};

export default BranchAvailabilityInfoContainer;
